import { Message as PrimeReactMessage, MessageProps } from 'primereact/message';
import { useMemo } from 'react';
import { Icon } from '../Icon/Icon';

export { Messages } from 'primereact/messages';

export function Message(props: MessageProps) {
    const messageIcon = useMemo(() => {
        if (props.icon) {
            return props.icon;
        }
        switch (props.severity) {
            case 'error':
                return <Icon name="block" fontSize="medium" />;
            case 'info':
                return <Icon name="info" fontSize="medium" />;
            case 'warn':
                return <Icon name="warning" fontSize="medium" />;
            case 'success':
                return <Icon name="check_circle" fontSize="medium" />;
            case 'contrast':
                return <Icon name="contrast" fontSize="medium" />;
        }
        return undefined;
    }, [props.severity, props.icon]);
    return <PrimeReactMessage {...props} icon={messageIcon} />;
}
